import React, { useState, useEffect } from 'react';
import { MessageCircle, X, Youtube } from 'lucide-react';

const SocialMediaButtons = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);
  
  const whatsappNumber = '919696252549';
  const whatsappMessage = 'Hello! I am interested in Varun Solar Energy solutions.';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  const youtubeLink = 'https://www.youtube.com/channel/UC6CD1pf3yCl9u-f_F-RsBIQ';
  const facebookLink = 'https://facebook.com/p/Varun-Solar-Energy-61566361151186/';

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 2000);
    const tooltipTimer = setTimeout(() => setShowTooltip(false), 8000);
    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {/* Social Media Floating Buttons */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4">
        {/* Tooltip */}
        {showTooltip && (
          <div className="relative bg-white rounded-lg shadow-2xl p-4 max-w-xs animate-bounce">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              aria-label="Close tooltip"
            >
              <X className="w-4 h-4" />
            </button>
            <p className="text-sm text-gray-800 font-medium pr-4">
              Connect with us! 💬 📺 👍
            </p>
            <div className="absolute bottom-0 right-8 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white"></div>
          </div>
        )}

        {/* YouTube Button */}
        <a
          href={youtubeLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative bg-red-600 hover:bg-red-700 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110"
          aria-label="Visit our YouTube Channel"
        >
          <Youtube className="w-7 h-7" />
          <span className="absolute inset-0 rounded-full bg-red-400 opacity-0 group-hover:opacity-20 group-hover:animate-ping"></span>
          
          {/* Hover tooltip */}
          <span className="absolute right-16 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            <span className="bg-gray-900 text-white text-xs font-medium px-3 py-2 rounded-lg shadow-lg">
              YouTube Channel
            </span>
          </span>
        </a>

        {/* Facebook Button */}
        <a
          href={facebookLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative bg-blue-600 hover:bg-blue-700 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110"
          aria-label="Visit our Facebook Page"
        >
          <svg className="w-7 h-7" fill="currentColor" viewBox="0 0 24 24">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
          <span className="absolute inset-0 rounded-full bg-blue-400 opacity-0 group-hover:opacity-20 group-hover:animate-ping"></span>
          
          {/* Hover tooltip */}
          <span className="absolute right-16 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            <span className="bg-gray-900 text-white text-xs font-medium px-3 py-2 rounded-lg shadow-lg">
              Facebook Page
            </span>
          </span>
        </a>

        {/* WhatsApp Button */}
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 animate-pulse"
          aria-label="Chat on WhatsApp"
        >
          <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
          
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center animate-ping">
            <span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
          </span>
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">1</span>
          
          <span className="absolute inset-0 rounded-full bg-green-400 opacity-0 group-hover:opacity-20 group-hover:animate-ping"></span>
          
          {/* Hover tooltip */}
          <span className="absolute right-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            <span className="bg-gray-900 text-white text-xs font-medium px-3 py-2 rounded-lg shadow-lg">
              Chat on WhatsApp
            </span>
          </span>
        </a>
      </div>
    </>
  );
};

export default SocialMediaButtons;
